import { useQuery } from "@tanstack/react-query";
import { useApi } from "@utils/useApi";
import {
  ProductSearchDto,
  ProductSearchClient,
} from "@lib/ShiOneClient";
import ms from "ms";

export interface Pagination {
  page: number;
  pageSize: number;
}

export interface SearchProductRequest {
  orgUnitId?: number | null;
  catalogId?: number | null;
  query?: string;
  pagination?: Pagination;
  top?: number;
  isReturnPagingInfo?: boolean;
}

const PAGE_SIZE = 25;
const SEARCH_PRODUCT_QUERY_KEY = "ecommerce-search-products"

export const useQueryProduct = (
  request?: SearchProductRequest,
) => {
  const api = useApi(ProductSearchClient);

  const { orgUnitId, catalogId, query, pagination, top, isReturnPagingInfo } =
    request ?? {};

  const page = pagination?.page ?? 0;
  const pageSize = pagination?.pageSize ?? PAGE_SIZE;

  const isEnabled =
    !!orgUnitId &&
    !!catalogId &&
    !!query?.length;

  const searchProducts = async () => {
    const dto = new ProductSearchDto({
      orgUnitId: orgUnitId!,
      catalogId: catalogId!,
      query: query!,
      page,
      pageSize,
      top,
      isReturnPagingInfo,
      isRelatedProductOnly: false,
    });

    return await api.searchProducts(dto);
  }

  return useQuery({
    queryKey: [
      SEARCH_PRODUCT_QUERY_KEY,
      {
        orgUnitId,
        catalogId,
        query,
        page,
        pageSize,
        top,
      },
    ],
    queryFn: searchProducts,
    staleTime: ms("10m"),
    cacheTime: ms("15m"),
    retry: false,
    enabled: isEnabled,
  });
}

export default useQueryProduct;
